// import external dependencies
// Import everything from autoload
import './autoload/_polyfill';

// import local dependencies
import './util/cursorElement';
import Router from './util/Router';
import Footprint from './util/Footprint';
import common from './routes/common';
import top from './routes/top';
import profile from './routes/profile';
import single from './routes/single';
import singleProjects from './routes/singleProjects';
import contact from './routes/contact';
import barba from './barba';

const footprint = new Footprint();

/** Populate Router instance with DOM routes */
const router = new Router({
  common,
  top,
  profile,
  single,
  singleProjectsJa: singleProjects,
  singleProjectsEn: singleProjects,
  contact
});

// Load Events
jQuery(document).ready(() => {
  common.initOnce(router)
  router.loadEvents()
  footprint.init()
  barba.init(router, footprint)
});
